import {
  ReactNode, useCallback,
  useContext,
  useMemo
} from "react";
import {useUser} from "./useUser";
import queryString from "query-string";
import {omitBy} from "lodash";
import {RouteMeta, SecureRoutesContext} from "components/Admin/Secure/SecureRoutes/SecureRoutes";
import {useTranslate} from "react-admin";

export interface NavLink {
  path: string;
  label: string;
  icon: ReactNode;
  onClick?: () => void;
}

export const useNavLinks = () => {
  const context = useContext(SecureRoutesContext);

  const t = useTranslate();

  const {userHasOneOfPermissions} = useUser();

  const getLabel = useCallback((route: RouteMeta) => {
    if (route.label) {
      return t(route.label, {_: route.label});
    }

    if (route.resource) {
      return t(`resources.${route.resource}.name`, {_: route.resource, smart_count: 2 });
    }

    return route.path
  }, [t])

  const navLinks: NavLink[] = useMemo(() => {
    return context.meta
      .filter(
        (route) =>
          route.showInNavbar && userHasOneOfPermissions(route.permissions)
      )
      .map((route) => ({
        path: `${route.path}?${queryString.stringify(
          omitBy(route.params, (value: any) => value === "" || value == null)
        )}`,
        label: getLabel(route),
        icon: route.icon,
        onClick: route.onClick,
      }));
  }, [context.meta, getLabel, userHasOneOfPermissions]);

  return {
    navLinks,
  };
};
